
import React from "react";
import styles from "../../assets/style.module.css";

export interface PageHeadProps {
    kicker?: string;
    title: string;
    subtitle?: string;
    children?: React.ReactNode;
}

function PageHead({ kicker, title, subtitle, children }: PageHeadProps) {
    return (<section className={styles["page-head"]}>
        <div className={styles["bg-overlay"]} />
        <div className={styles["container"]}>
            {kicker && (<div className={styles["page-kicker"]}>{kicker}</div>)}
            <h1 className={styles["d2"]}>{title}</h1>
            {subtitle && (<p className={styles["lead"]}>{subtitle}</p>)}
            {children}
        </div>
    </section>);
}

export default PageHead;
